/* eslint-disable */
import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Popover,
  TextField,
  Button,
  Typography,
  List,
  ListItem,
  Paper,
  InputAdornment,
  makeStyles,
  FormControlLabel,
  Box,
  Tooltip,
  Checkbox,
} from '@material-ui/core';
import ElegantSwitch from '../../../../../Shared/ElegantSwitch';
import {
  Search as SearchIcon,
  Info as InfoIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  popover: {
    '& .MuiPopover-paper': {
      width: 700,
      maxWidth: '90vw',
      maxHeight: '80vh',
      minHeight: 550,
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 12,
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.16)',
    },
  },
  leftPanelSearch: {
    padding: theme.spacing(1),
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #e9ecef',
    flexShrink: 0,
  },
  controlPanel: {
    padding: theme.spacing(1),
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #e9ecef',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  automationHeader: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#2d3748',
    marginRight: theme.spacing(2),
  },
  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    borderBottom: '1px solid #e9ecef',
    backgroundColor: '#f8f9fa',
  },
  tableHeaderItem: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#2d3748',
    flex: 1,
  },
  tableHeaderAutomation: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#2d3748',
    width: 100,
    textAlign: 'center',
  },
  clearAllButton: {
    height: 36,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: '0.75rem',
    textTransform: 'none',
    backgroundColor: '#8E8E8E',
    color: '#FFFFFF',
    borderRadius: 6,
    '&:hover': {
      backgroundColor: '#7A7A7A',
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      backgroundColor: '#8E8E8E',
    },
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 6,
      backgroundColor: '#ffffff',
      height: 36,
      fontSize: '0.875rem',
    },
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  scrollableContent: {
    flex: 1,
    overflow: 'hidden',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  listsContainer: {
    display: 'flex',
    flex: 1,
    gap: 0,
    position: 'relative',
    minHeight: 0,
  },
  verticalDivider: {
    width: 1,
    backgroundColor: '#e9ecef',
    margin: theme.spacing(0, 2),
    alignSelf: 'stretch',
  },
  listPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    minHeight: 0,
  },
  listHeader: {
    padding: theme.spacing(1, 2, 0, 2),
    backgroundColor: '#f8f9fa',
    borderRadius: '8px 8px 0 0',
    flexShrink: 0,
  },
  listHeaderTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: '#2d3748',
  },
  listHeaderSubtitle: {
    fontSize: '0.75rem',
    color: '#718096',
  },
  listContent: {
    flex: 1,
    overflow: 'auto',
    backgroundColor: 'white',
    border: '1px solid #e9ecef',
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
  },
  listItem: {
    borderBottom: '1px solid #f1f3f4',
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: '#f8f9fa',
    },
  },
  selectedListItem: {
    borderBottom: '1px solid #f1f3f4',
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    cursor: 'default',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: '#f8f9fa',
    },
  },
  itemContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  itemTitle: {
    flex: 1,
    fontWeight: 500,
    fontSize: '0.875rem',
    color: '#2d3748',
    paddingLeft: theme.spacing(1),
    wordBreak: 'break-word',
  },
  itemEndSection: {
    width: 42, // Same width as ElegantSwitch
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexShrink: 0,
  },
  highlightedText: {
    backgroundColor: '#fff3cd',
    padding: '1px 2px',
    borderRadius: '2px',
  },
  infoIcon: {
    fontSize: 16,
    color: '#a0aec0',
    cursor: 'help',
    '&:hover': {
      color: '#718096',
    },
  },
  infoIconPlaceholder: {
    width: 16,
    height: 16,
  },
  tooltip: {
    maxWidth: 300,
    fontSize: '0.75rem',
    backgroundColor: 'rgba(0, 0, 0, 0.87)',
  },
  automationSwitch: {
    width: 42, // Same width as itemEndSection
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    '& .MuiSwitch-root': {
      margin: 0,
    },
  },
  selectedItemContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  selectedItemTitle: {
    flex: 1,
    fontWeight: 500,
    fontSize: '0.875rem',
    color: '#2d3748',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
  },
  selectedItemActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(0.5),
  },
  checkbox: {
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(-0.5),
  },
  deleteButton: {
    padding: 4,
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(3),
    color: '#718096',
    fontSize: '0.875rem',
  },
  actionButtons: {
    padding: theme.spacing(2),
    backgroundColor: '#fafafa',
    borderTop: '1px solid #e9ecef',
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  actionButton: {
    borderRadius: 6,
    textTransform: 'none',
    fontSize: '0.875rem',
    padding: theme.spacing(0.75, 2),
  },
}));

const MultiSelectPopover = ({
  anchorEl,
  open,
  onClose,
  title,
  availableItems,
  selectedItems,
  onApply,
  showAutomation = false,
  searchPlaceholder = 'Search items...',
}) => {
  const classes = useStyles();
  const [searchQuery, setSearchQuery] = useState('');
  const [localSelectedItems, setLocalSelectedItems] = useState(selectedItems || []);
  const searchInputRef = useRef(null);

  // Normalize selected items to ensure consistent format and remove duplicates
  const normalizeSelectedItems = (items) => {
    if (!Array.isArray(items)) return [];

    const normalizedItems = items.map(item => {
      // If item is already in the correct format (has enableAutomation and key)
      if (typeof item === 'object' && item.hasOwnProperty('key')) {
        return {
          key: item.key,
          enableAutomation: item.enableAutomation || false,
        };
      }

      // If item is just a string key (resources format)
      if (typeof item === 'string') {
        return {
          key: item,
          enableAutomation: false,
        };
      }

      return null;
    }).filter(Boolean);

    // Remove duplicates based on key
    const uniqueItems = [];
    const seenKeys = new Set();

    normalizedItems.forEach(item => {
      if (!seenKeys.has(item.key)) {
        seenKeys.add(item.key);
        uniqueItems.push(item);
      }
    });

    return uniqueItems;
  };

  // Update local state when selectedItems prop changes
  useEffect(() => {
    setLocalSelectedItems(normalizeSelectedItems(selectedItems || []));
  }, [selectedItems]);

  // Filter and sort available items based on search
  const filteredAvailableItems = useMemo(() => {
    let items = availableItems;

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      items = items.filter(item =>
        item.title.toLowerCase().includes(query)
      );
    }

    // Sort alphabetically by title
    return [...items].sort((a, b) =>
      a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
    );
  }, [availableItems, searchQuery]);

  // Check if item is selected
  const isItemSelected = useCallback((key) => {
    return localSelectedItems.some(item => item.key === key);
  }, [localSelectedItems]);

  // Get full data for selected items and sort alphabetically
  const selectedItemsWithData = useMemo(() => {
    const itemsWithData = localSelectedItems.map(selectedItem => {
      const fullItem = availableItems.find(item => item.key === selectedItem.key);
      return {
        ...selectedItem,
        ...fullItem,
      };
    }).filter(Boolean);

    // Sort alphabetically by title
    return itemsWithData.sort((a, b) =>
      a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
    );
  }, [localSelectedItems, availableItems]);

  // Function to highlight search matches
  const highlightSearchMatch = useCallback((text, query) => {
    if (!query.trim()) return text;

    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedQuery})`, 'gi'));
    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span key={index} className={classes.highlightedText}>
          {part}
        </span>
      ) : (
        part
      )
    );
  }, [classes.highlightedText]);

  const handleToggleItem = useCallback((item) => {
    setLocalSelectedItems(prev => {
      const isSelected = prev.some(selectedItem => selectedItem.key === item.key);

      if (isSelected) {
        // Remove item
        return prev.filter(selectedItem => selectedItem.key !== item.key);
      } else {
        // Add item - ensure no duplicates
        const newSelectedItem = {
          key: item.key,
          enableAutomation: false,
        };

        // Remove any existing items with the same key before adding
        const filteredItems = prev.filter(selectedItem => selectedItem.key !== item.key);
        return [...filteredItems, newSelectedItem];
      }
    });
  }, []);

  const handleRemoveItem = useCallback((key) => {
    setLocalSelectedItems(prev => prev.filter(item => item.key !== key));
  }, []);

  const handleToggleAutomation = useCallback((key, enabled) => {
    setLocalSelectedItems(prev => prev.map(item => {
      if (item.key === key) {
        const fullItem = availableItems.find(availableItem => availableItem.key === key);
        // Only allow enabling automation if the item supports it
        const canEnableAutomation = fullItem && fullItem.hasAutomation;
        return {
          ...item,
          enableAutomation: canEnableAutomation ? enabled : false
        };
      }
      return item;
    }));
  }, [availableItems]);

  const handleApply = useCallback(() => {
    try {
      onApply(localSelectedItems);
      handleClose();
    } catch (error) {
      console.error('Error applying selection:', error);
    }
  }, [localSelectedItems, onApply]);

  const handleClose = useCallback(() => {
    setLocalSelectedItems(normalizeSelectedItems(selectedItems || []));
    setSearchQuery('');
    onClose();
  }, [selectedItems, onClose]);

  const handleClearAll = useCallback(() => {
    setLocalSelectedItems([]);
  }, []);

  // Check if user has made changes
  const hasChanges = useMemo(() => {
    const normalizedOriginalItems = normalizeSelectedItems(selectedItems || []);

    if (normalizedOriginalItems.length !== localSelectedItems.length) {
      return true;
    }

    return normalizedOriginalItems.some(originalItem => {
      const localItem = localSelectedItems.find(item => item.key === originalItem.key);
      return !localItem || localItem.enableAutomation !== originalItem.enableAutomation;
    });
  }, [selectedItems, localSelectedItems]);

  // Handle backdrop click - only allow close if no changes
  const handleBackdropClick = useCallback((event) => {
    if (hasChanges) {
      event.stopPropagation();
      return;
    }
    handleClose();
  }, [hasChanges, handleClose]);

  // Auto-focus search input when popover opens
  useEffect(() => {
    if (open && searchInputRef.current) {
      const timeoutId = setTimeout(() => {
        try {
          const input = searchInputRef.current;
          // Try to access the actual input element
          const inputElement = input.querySelector('input') || input;
          if (inputElement && inputElement.focus) {
            inputElement.focus();
            inputElement.select();
          }
        } catch (error) {
          console.warn('Failed to focus search input:', error);
        }
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [open]);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={hasChanges ? null : handleClose}
      BackdropProps={{
        onClick: handleBackdropClick,
        invisible: true,
        style: {
          cursor: hasChanges ? 'not-allowed' : 'default',
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      className={classes.popover}
      disableAutoFocus={false}
      disableEnforceFocus={false}
    >
      <div className={classes.contentContainer}>
        {/* Scrollable Content */}
        <div className={classes.scrollableContent}>
          <div className={classes.listsContainer}>
            {/* Available items */}
            <Paper className={classes.listPanel} elevation={0}>
              <div className={classes.listHeader}>
                <Typography className={classes.listHeaderTitle}>
                  Available Items
                </Typography>
              </div>
              {/* Search in left panel */}
              <div className={classes.leftPanelSearch}>
                <TextField
                  fullWidth
                  placeholder={searchPlaceholder}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className={classes.searchField}
                  variant="outlined"
                  size="small"
                  autoFocus={open}
                  ref={searchInputRef}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className={classes.listContent}>
                {filteredAvailableItems.length === 0 ? (
                  <div className={classes.emptyState}>
                    {searchQuery ? 'No items match your search' : 'No items available'}
                  </div>
                ) : (
                  <List dense disablePadding>
                    {filteredAvailableItems.map(item => (
                      <ListItem
                        key={item.key}
                        className={classes.listItem}
                        onClick={() => handleToggleItem(item)}
                      >
                        <div className={classes.itemContent}>
                          <Checkbox
                            checked={isItemSelected(item.key)}
                            color="primary"
                            className={classes.checkbox}
                            onChange={() => handleToggleItem(item)}
                            onClick={(e) => e.stopPropagation()}
                            aria-label={`Select ${item.title}`}
                          />
                          <div className={classes.itemTitle}>
                            {highlightSearchMatch(item.title, searchQuery)}
                          </div>
                          <div className={classes.itemEndSection}>
                            {item.description && (
                              <Tooltip
                                title={item.description}
                                placement="top"
                                classes={{ tooltip: classes.tooltip }}
                                enterDelay={300}
                              >
                                <InfoIcon
                                  className={classes.infoIcon}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      </ListItem>
                    ))}
                  </List>
                )}
              </div>
            </Paper>

            {/* Vertical Divider */}
            <div className={classes.verticalDivider} />

            {/* Selected items */}
            <Paper className={classes.listPanel} elevation={0}>
              <div className={classes.listHeader}>
                <Typography className={classes.listHeaderTitle}>
                  Selected Items
                </Typography>
              </div>
              {/* Control panel with Clear All button and Automation header */}
              <div className={classes.controlPanel}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleClearAll}
                  className={classes.clearAllButton}
                  disabled={selectedItemsWithData.length === 0}
                >
                  Clear All
                </Button>
                {showAutomation && (
                  <Typography className={classes.automationHeader}>
                    Automation
                  </Typography>
                )}
              </div>
              <div className={classes.listContent}>
                {selectedItemsWithData.length === 0 ? (
                  <div className={classes.emptyState}>
                    No items selected
                  </div>
                ) : (
                  <>
                    <List dense disablePadding>
                      {selectedItemsWithData.map(item => (
                        <ListItem
                          key={item.key}
                          className={classes.selectedListItem}
                          disableRipple
                        >
                          <div className={classes.selectedItemContent}>
                            <Checkbox
                              checked={true}
                              color="primary"
                              className={classes.checkbox}
                              onChange={() => handleRemoveItem(item.key)}
                            />
                            <div className={classes.selectedItemTitle}>
                              {item.title}
                            </div>
                            {showAutomation ? (
                              <div className={classes.automationSwitch}>
                                {!item.hasAutomation ? (
                                  <Tooltip
                                    title="Automation is not available for this item"
                                    placement="top"
                                    classes={{ tooltip: classes.tooltip }}
                                    enterDelay={300}
                                  >
                                    <div>
                                      <ElegantSwitch
                                        checked={false}
                                        onChange={(e) => handleToggleAutomation(item.key, e.target.checked)}
                                        disabled={true}
                                      />
                                    </div>
                                  </Tooltip>
                                ) : (
                                  <ElegantSwitch
                                    checked={item.enableAutomation || false}
                                    onChange={(e) => handleToggleAutomation(item.key, e.target.checked)}
                                    disabled={false}
                                  />
                                )}
                              </div>
                            ) : (
                              <div className={classes.itemEndSection}/>
                            )}
                          </div>
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}
              </div>
            </Paper>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className={classes.actionButtons}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="outlined"
          className={classes.actionButton}
        >
          Cancel
        </Button>
        <Button
          onClick={handleApply}
          color="primary"
          variant="contained"
          className={classes.actionButton}
        >
          Apply
        </Button>
      </div>
    </Popover>
  );
};

MultiSelectPopover.propTypes = {
  anchorEl: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  availableItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    hasAutomation: PropTypes.bool,
  })).isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    enableAutomation: PropTypes.bool,
  })),
  onApply: PropTypes.func.isRequired,
  showAutomation: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
};

MultiSelectPopover.defaultProps = {
  selectedItems: [],
  showAutomation: false,
  searchPlaceholder: 'Search items...',
  anchorEl: null,
};

export default MultiSelectPopover;
